/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coaches_Empty_BodyInputs */

const en_portal_coaches_empty_body = /** @type {(inputs: Portal_Coaches_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As soon as a coach publishes their open times you'll see them on this page and book in one tap. Already have a coach? Open the link to their page and book there.`)
};

const pl_portal_coaches_empty_body = /** @type {(inputs: Portal_Coaches_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdy trener udostępni wolne terminy, zobaczysz je na tej stronie i zarezerwujesz trening jednym dotknięciem. Masz już trenera? Otwórz link do jego strony i rezerwuj tam.`)
};

/**
* | output |
* | --- |
* | "As soon as a coach publishes their open times you'll see them on this page and book in one tap. Already have a coach? Open the link to their page and book th..." |
*
* @param {Portal_Coaches_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coaches_empty_body = /** @type {((inputs?: Portal_Coaches_Empty_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coaches_Empty_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coaches_empty_body(inputs)
	return en_portal_coaches_empty_body(inputs)
});